const formatMoney = (value) => {
  if (!value && value !== 0) return "0";
  return Number(value).toLocaleString("th-TH", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
};

const formatDate = (dateStr) => {
  if (!dateStr) return "-";
  const date = new Date(dateStr);
  return date.toLocaleDateString("th-TH", {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
};

// รวมตารางดิว (ทำยอม) กับข้อมูลเบี้ยปรับ — ถ้างวดไหนมีเบี้ยปรับ ให้แทรกต่อจากแถวดิวงวดนั้น
const mergeDuePaymentWithPenalty = (dueRows = [], penaltyRows = []) => {
  const sortedDue = [...(dueRows || [])].sort(
    (a, b) => Number(a.NOPAY) - Number(b.NOPAY),
  );
  const merged = [];
  sortedDue.forEach((due) => {
    merged.push({ ...due, __rowType: "due", _key: `due-${due.id}` });
    (penaltyRows || [])
      .filter((p) => Number(p.NOPAY) === Number(due.NOPAY))
      .forEach((p, idx) => {
        merged.push({
          ...p,
          __rowType: "penalty",
          _key: `penalty-${due.NOPAY}-${idx}`,
        });
      });
  });
  return merged;
};

const getDocLabel = (menuType, imageType) => {
  if (menuType === 5 && imageType === 3)
    return { label: "ไฟล์คำฟ้อง", color: "#d46b08" }; // ส้มเข้ม
  if (menuType === 5 && imageType === 4)
    return { label: "ใบเสร็จศาลคำฟ้อง", color: "#d46b08" }; // ส้มเข้ม
  if (menuType === 6 && imageType === 7)
    return { label: "คำพิพากษา", color: "#096dd9" }; // น้ำเงินเข้ม
  if (menuType === 6 && imageType === 8)
    return { label: "คำพิพากษา(ทำยอม)", color: "#096dd9" }; // น้ำเงินเข้ม
  if (menuType === 6 && imageType === 9)
    return { label: "ถอนฟ้อง", color: "#096dd9" }; // น้ำเงินเข้ม
  if (menuType === 6 && imageType === 10)
    return { label: "ใบเสร็จศาลหลังพิพากษา", color: "#389e0d" }; // เขียวเข้ม
  if (menuType === 6 && imageType === 12)
    return { label: "วางคำบังคับ", color: "#096dd9" }; // น้ำเงินเข้ม
  if (menuType === 8 && imageType === 13)
    return { label: "บัดตัดจ่าย", color: "#096dd9" }; // น้ำเงินเข้ม
  if (menuType === 8 && imageType === 14)
    return { label: "ใบเสร็จปิดบัญชี", color: "#096dd9" }; // น้ำเงินเข้ม
  return { label: "เอกสารอื่น ๆ", color: "#595959" }; // เทาเข้ม
};
// ── กำหนด filter ตาม currentStatus / closeContno ──────────────
const getAllowedTypes = (judgeData) => {
  let status;
  if (judgeData?.judge?.length === 0 || !judgeData?.judge) {
    status = judgeData?.currentStatus;
  } else {
    status = judgeData?.judge?.[0]?.currentStatus;
  }
  const closeContno = judgeData?.judge?.[0]?.closeContno;
  const allowed = [];

  if (status > 3 && status !== 6 && status !== 7) {
    allowed.push({ menuType: 5, imageType: 3 });
    allowed.push({ menuType: 5, imageType: 4 });
  }
  if (status > 7) {
    allowed.push({ menuType: 6, imageType: 7 });
    allowed.push({ menuType: 6, imageType: 8 });
    allowed.push({ menuType: 6, imageType: 9 });
  }
  if (status > 11) {
    allowed.push({ menuType: 6, imageType: 10 });
    allowed.push({ menuType: 6, imageType: 12 });
  }
  if (closeContno === 0) {
    allowed.push({ menuType: 8, imageType: 13 });
    allowed.push({ menuType: 8, imageType: 14 });
  }
  console.log("allowed", allowed);

  return allowed;
};

const getMenuTypesToLoad = (judgeData) => {
  const allowed = getAllowedTypes(judgeData);
  return [...new Set(allowed.map((a) => a.menuType))];
};

// ── ตัดบันทัดว่างซ้ำให้เหลือแค่ 1 บันทัด ──────────────
const collapseBlankLines = (text) =>
  text ? text.replace(/\r\n/g, "\n").replace(/\n{3,}/g, "\n\n") : text;

const getFileType = (path = "") => {
  const ext = path.toLowerCase().split(".").pop();
  if (ext === "pdf") return "pdf";
  if (["jpg", "jpeg", "png", "gif", "webp"].includes(ext)) return "image";
  return "other";
};

const mailStatusOptions = [
  {
    value: 1,
    label: "ตอบกลับ",
    icon: "✅ ",
    color: "success", // สีเขียว
  },
  {
    value: 2,
    label: "ตีกลับ",
    icon: "↩️ ",
    color: "error", // สีแดง
  },
  {
    value: 3,
    label: "ส่งถึงแล้วไม่ตอบกลับ",
    icon: "📬 ",
    color: "warning", // สีส้ม/เหลือง
  },
  {
    value: 4,
    label: "ไม่มีการเคลื่อนไหว (เกิน 20 วัน)",
    icon: "🛑 ",
    color: "default", // สีเทา
  },
];

export {
  formatMoney,
  formatDate,
  mergeDuePaymentWithPenalty,
  getDocLabel,
  getAllowedTypes,
  getMenuTypesToLoad,
  getFileType,
  mailStatusOptions,
  collapseBlankLines,
};
